(() => {
  if (customElements.get('berrys-review-summary')) return;
  let summaryRequest;

  function loadSummary() {
    if (!summaryRequest) {
      const url = new URL('https://api.reviews.io/merchant/reviews');
      url.searchParams.set('store', 'berens-and-co-ta-berrys-jewellers');
      url.searchParams.set('per_page', '1');
      summaryRequest = fetch(url, {
        credentials: 'omit',
        referrerPolicy: 'no-referrer',
        signal: AbortSignal.timeout(8000)
      })
        .then(response => {
          if (!response.ok) throw new Error('Review summary unavailable');
          return response.json();
        })
        .then(data => {
          const rating = Number(data?.stats?.average_rating);
          const count = Number(data?.stats?.total_reviews);
          if (!Number.isFinite(rating) || rating < 1 || rating > 5 ||
              !Number.isSafeInteger(count) || count < 1) {
            throw new Error('Review summary unavailable');
          }
          return { rating, count };
        })
        .catch(error => {
          summaryRequest = undefined;
          throw error;
        });
    }
    return summaryRequest;
  }

  customElements.define('berrys-review-summary', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => this.loadRating());
    }

    loadRating() {
      if (!this.isConnected) return;
      const output = this.querySelector('[data-review-summary]');
      if (!output || !this.dataset.summaryTemplate) return;
      loadSummary().then(({ rating, count }) => {
        if (!this.isConnected) return;
        const locale = document.documentElement.lang || 'en-GB';
        const score = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(rating);
        const total = new Intl.NumberFormat(locale).format(count);
        output.textContent = this.dataset.summaryTemplate.replace('[rating]', score).replace('[count]', total);
        output.hidden = false;
      }).catch(() => {
        output.hidden = true;
      });
    }
  });
})();
